import createIcon from '../../createIcon';

/**
 * @component @name Inventory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzMgMiAyIDIuOSAyIDRWNy4wMUMyIDcuNzMgMi40MyA4LjM1IDMgOC43VjIwQzMgMjEuMSA0LjEgMjIgNSAyMkgxOUMxOS45IDIyIDIxIDIxLjEgMjEgMjBWOC43QzIxLjU3IDguMzUgMjIgNy43MyAyMiA3LjAxVjRDMjIgMi45IDIxIDIgMjAgMlpNMTUgMTRIOVYxMkgxNVYxNFpNMjAgN0g0VjRMMjAgMy45OFY3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Inventory = createIcon('Inventory', [
  [
    'path',
    {
      d: 'M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM15 14H9V12H15V14ZM20 7H4V4L20 3.98V7Z',
      key: '14zox5',
    },
  ],
]);

export default Inventory;
